export default __webpack_public_path__ + "static/media/horizontalCollage.7b7e4fac.png";